<span class="part-status part-status--{{ status().klass }}">
  {{ status().value }}
</span>
